module.exports = __webpack_public_path__ + "media/components/shared/static/footer_img-8ca86af7afb5014814b06599180da26d.svg";